import { createApi } from '@reduxjs/toolkit/query/react'
import { authenticatedBaseQuery } from './baseQuery'

export const userCRUDApi = createApi({
  reducerPath: 'userCRUDApi',
  baseQuery: authenticatedBaseQuery,
  tagTypes: ['Customer', 'Staff'],
  endpoints: (builder) => ({
    getAllCustomers: builder.query({
      query: () => 'user/getAllcustomers/',
      providesTags: ['Customer'],
    }),
    getAllStaff: builder.query({
      query: () => 'user/getAllstaff/',
      providesTags: ['Staff'],
    }),
    getUser: builder.query({
      query: (id) => `user/Uprofile/${id}`,
    }),
    getLoggedUser: builder.query({
      query: () => 'user/profile/',
    }),
    updateUser: builder.mutation({
      query: (user) => {
        const { id, ...rest } = user
        return {
          url: `user/update/${id}`,
          method: 'PUT',
          body: rest,
        }
      },
      invalidatesTags: ['Customer', 'Staff'],
    }),
    deleteUser: builder.mutation({
      query: (id) => ({
        url: `user/delete/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Customer', 'Staff'],
    }),
    registerStaff: builder.mutation({
      query: (user) => ({
        url: 'user/registerStaff/',
        method: 'POST',
        body: user,
      }),
      invalidatesTags: ['Staff'],
    }),
    changePassword: builder.mutation({
      query: (data) => ({
        url: 'user/change-password/',
        method: 'POST',
        body: data,
      }),
    }),
  }),
})

export const {
  useGetAllCustomersQuery,
  useGetAllStaffQuery,
  useGetLoggedUserQuery,
  useGetUserQuery,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useRegisterStaffMutation,
  useChangePasswordMutation,
} = userCRUDApi
